import { request } from "../helpers/axios.new";

export const GET_SETTING = (key) => {
  return request({
    url: `/settings/${key}`,
    method: "GET",
  });
};
